import IpcRouter from '@shared/ipc/IpcRouter.ts'
import {
  MicrophoneRequestOutcome,
  PermissionAssistantPanel,
  ScreenCaptureRequestOutcome,
  ScreenCaptureStatus,
  SystemAudioCaptureStatus,
  SystemAudioRequestOutcome,
  SystemSetting,
} from '@shared/types/Aries'

export interface AriesIpcRouterType {
  checkAccessibilityPerm: () => Promise<boolean>
  checkScreenCaptureStatus: () => Promise<ScreenCaptureStatus>
  requestScreenCapturePerm: () => Promise<ScreenCaptureRequestOutcome>
  checkMicrophonePerm: () => Promise<boolean>
  requestMicrophonePerm: () => Promise<MicrophoneRequestOutcome>
  checkSystemAudioCapturePerm: () => Promise<SystemAudioCaptureStatus>
  requestSystemAudioCapturePerm: () => Promise<SystemAudioRequestOutcome>
  openSystemSettings: (setting: SystemSetting) => Promise<void>
  presentPermissionAssistant: (panel: PermissionAssistantPanel) => Promise<void>
  dismissPermissionAssistant: () => Promise<void>
}

class AriesIpcRouter extends IpcRouter<AriesIpcRouterType> {
  constructor() {
    super('aries', {
      checkAccessibilityPerm: true,
      checkScreenCaptureStatus: true,
      requestScreenCapturePerm: true,
      checkMicrophonePerm: true,
      requestMicrophonePerm: true,
      checkSystemAudioCapturePerm: true,
      requestSystemAudioCapturePerm: true,
      openSystemSettings: true,
      presentPermissionAssistant: true,
      dismissPermissionAssistant: true,
    })
  }
}

export default AriesIpcRouter
